// Necessary to infer types when using vue-property-decorator
import "reflect-metadata"
import Vue from "vue"
import "./dependencies"
import Axios from "axios"
import {isSupportedBrowser} from "@/utils/isSupportedBrowser"
import {PlanSuperScoreService} from "@/superscore/PlanSuperScoreService"
import {CampaignService} from "@/CampaignService"
import {PlanService} from "@/superannuation/PlanService"
import {DateRangeService} from "@/DateRangeService"
import {NewsService} from "@/news/NewsService"
import * as am4core from "@amcharts/amcharts4/core"
import animatedTheme from "@amcharts/amcharts4/themes/animated"

import {apm} from "./rum"
import App from "./App.vue"
import {AuthenticationService} from "./AuthenticationService"
import {CalculationVariableService} from "./CalculationVariableService"
import {AsfaVariableService} from "./AsfaVariableService"
import {ActuatorService} from "./ActuatorService"

declare const SERVICE_VERSION: string

Axios.defaults.withCredentials = true

// XSRF prevention
Axios.defaults.headers.post["X-Requested-By"] = "SSN"

const nonSupportedBrowser = <HTMLElement>document.body.querySelector("#non-supported-browser")

am4core.useTheme(animatedTheme)

// @formatter:off
if (isSupportedBrowser) {
  nonSupportedBrowser.remove()
  const planService = Vue.observable(new PlanService())
  const campaignService = Vue.observable(new CampaignService())
  const dateRangeService = Vue.observable(new DateRangeService(campaignService))
  const newsService = Vue.observable(new NewsService())
  const actuatorService = Vue.observable(new ActuatorService())
  new Vue({
    el: "#app",
    provide: {
      authenticationService: Vue.observable(new AuthenticationService()),
      planSuperScoreService: Vue.observable(new PlanSuperScoreService()),
      planService,
      campaignService,
      dateRangeService,
      newsService,
      calculationVariableService: Vue.observable(new CalculationVariableService()),
      asfaVariableService: Vue.observable(new AsfaVariableService()),
      actuatorService,
    },
    render: h => h(App),
  })
  ;(<any>window).ssn = {version: SERVICE_VERSION}

  apm.setInitialPageLoadName("Main")
} else {
  nonSupportedBrowser.style.display = "unset"
}
